import { render } from "./AdminNotificationList.vue?vue&type=template&id=3e67eec7&scoped=true&ts=true&lang=true"
import script from "./AdminNotificationList.vue?vue&type=script&lang=ts"
export * from "./AdminNotificationList.vue?vue&type=script&lang=ts"

import "./AdminNotificationList.vue?vue&type=style&index=0&id=3e67eec7&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e67eec7"]])

export default __exports__